import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '.';

export const reducers = {
  setInsertsData(state, action: PayloadAction<any>) {
    state.isLoading = true;
  },
  setInsertsSuccess(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = action.payload;
    state.error = null;
  },
  setInsertsFailure(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
